<template>
  <div class="setup-page">
    <SetupWizard
      v-model="showWizard"
      @setup-completed="onSetupCompleted"
      @setup-failed="onSetupFailed"
    />
  </div>
</template>

<script>
import SetupWizard from '@/components/Workforce/Dashboard/SetupWizard.vue'

export default {
  name: 'SetupPage',
  components: {
    SetupWizard
  },
  data() {
    return {
      showWizard: true
    }
  },
  methods: {
    async onSetupCompleted() {
      this.$storage.setUniversal('hasCompletedSetup', true)
      localStorage.removeItem('needsInitialSetup')

      try {
        const res = await this.$axios.get('/cualitywork/auth-user')
        this.$storage.setUniversal('user', { ...res.data })
        this.$store.dispatch('setWfmPermissions', res.data.wfmPermissions)
      } catch (error) {
        console.error('Failed to refresh user data after setup:', error)
      }

      this.$router.replace('/workforce/dashboard').catch((err) => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Navigation error:', err)
        }
      })
    },
    onSetupFailed(error) {
      console.error('Setup failed:', error)
      this.$toast.error('Setup failed. Please try again.')
    }
  }
}
</script>

<style scoped>
.setup-page {
  min-height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
